<template>
  <ValidationObserver
    v-slot="{ invalid, errors }"
    slim
  >
    <div
      class="bs-callout parse-setting__container bs-callout-primary"
    >
      <button
        class="btn btn-function parse-setting__btn-remove"
        type="button"
        @click="removeItem"
      >
        <i class="fa fa-times" />
      </button>
      <fieldset>
        <div class="form-group">
          <label
            v-t="'PARSE_TYPE'"
            class="control-label col-md-4 col-sm-4"
          >
            <a
              v-tooltip.right="'tooltip'"
            >
              &nbsp;&nbsp;<i class="fa fa-question-circle" />
            </a>
          </label>
          <div class="col-sm-7 col-md-7">
            <SearchableDropdown
              v-model="selectedParsingType"
              class="m-b-10"
              :config="parsingTypeDropdownConfig"
              :clearable="false"
            />
          </div>
        </div>
        <div class="form-group">
          <label
            v-t="'PARSE_EXPRESSION'"
            class="control-label col-md-4 col-sm-4"
          >
            <a
              v-tooltip.right="'tooltip'"
            >
              &nbsp;&nbsp;<i class="fa fa-question-circle" />
            </a>
          </label>
          <ValidationProvider
            v-slot="{ classes }"
            ref="parseExpression"
            :immediate="false"
            :custom-messages="validationMessage"
            vid="parseExpression"
            rules="required"
            slim
          >
            <div :class="classes">
              <div class="col-sm-7 col-md-7">
                <PrismEditor
                  v-if="value.type.toLowerCase() == 'javascript'"
                  v-model="body"

                  name="parseExpression"
                  class="m-t-10 m-b-10"
                  :highlight="highlighter"
                  :line-mumbers="false"
                />
                <input
                  v-else
                  v-model="body"
                  type="text"
                  name="parseExpression"
                  autocomplete="off"
                  class="form-control"
                >
                <span
                  v-if="isFailing(invalid, errors)"
                  class="form-group__label-required"
                >
                  {{ errors['parseExpression'][0] }}
                </span>
              </div>
            </div>
          </ValidationProvider>
        </div>
      </fieldset>
    </div>
  </ValidationObserver>
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-javascript';
import { PrismEditor } from 'vue-prism-editor';
import sharedMessages from '@/core/locales';

export default {
  name: 'HttpParseSetting',
  components: { SearchableDropdown, PrismEditor },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          type: 'jpath',
          value: '',
        };
      }
    },
  },
  computed: {
    parsingTypeDropdownConfig() {
      return {
        options: [
          { label: 'JPath', id: 'jpath' },
          { label: 'XPath', id: 'xpath' },
          { label: 'Regular Expression', id: 'regex' },
          { label: 'Javascript', id: 'javascript' },
        ],
        placeholder: 'Choose Parsing Type',
      };
    },
    selectedParsingType: {
      get() {
        return this.parsingTypeDropdownConfig.options.find( ({ id }) => id === this.value.type.toLowerCase() );
      },
      set(newType) {
        this.$emit('input', { type: newType.id, value: this.value.value });
      }
    },
    body: {
      get() {
        return this.value.value;
      },
      set(newValue) {
        this.$emit('input', { type: this.value.type, value: newValue });
      }
    },
    validationMessage() {
      return { ['required']: 'Parsing Expression is Required' };
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js, 'js');
    },
    removeItem() {
      this.$emit('remove');
    },
    isFailing(isInvalid, errors) {
      return isInvalid && errors['parseExpression'] && errors['parseExpression'].length > 0;
    }
  },
  i18n: {
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
.parse-setting__btn-remove {
  position: absolute;
  top: 10px;
  right: 10px;
}
.parse-setting__container {
  margin: 0;
  padding: 0;
  position: relative;
}
</style>